const data = [
  {
    id: 1,
    name: 'Home Battery',
    price: 35000.99,
    currency: 'EUR',
    image: 'images/01.jpg',
  },
  {
    id: 2,
    name: 'Polycrystalline Solar Panel',
    price: 299.99,
    currency: 'EUR',
    image: 'images/02.jpg',
  },
  {
    id: 4,
    name: 'Home EV unit',
    price: 549.99,
    currency: 'EUR',
    image: 'images/04.jpg',
  },
  {
    id: 6,
    name: '1 years green energy subscription (monthly pack)',
    price: 289.99,
    currency: 'EUR',
    image: 'images/06.jpg',
  },
  {
    id: 5,
    name: '2 years green energy subscription (monthly pack)',
    price: 249.99,
    currency: 'EUR',
    image: 'images/05.jpg',
  },
  {
    id: 3,
    name: 'Yearly energy service premium plan',
    price: 1199.99,
    currency: 'EUR',
    image: 'images/03.jpg',
  }
];

export default data;
